import {
  CREATE_RESOURCE_SUCCESS,
  FETCH_RESOURCE_SUCCESS,
  GET_RESOURCE_SUCCESS,
  SAVE_RESOURCE_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_RESOURCE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_RESOURCE_SUCCESS: {
      const query = JSON.parse(JSON.stringify(state.query));
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_RESOURCE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_RESOURCE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
